module.exports = __webpack_public_path__ + "img/web_05.69df0a5a.png";